export default "__VITE_ASSET__BWgz4rT9__"